import { useRef, useState } from "react";
import { Microphone } from "@phosphor-icons/react";
import { toast } from "sonner";

const clean = (s) => s.trim().replace(/^[।.?!,\s]+/, "").replace(/[।.?!,\s]+$/, "");

export const VoiceTypingButton = ({ onText, inputRef, className = "" }) => {
  const recRef = useRef(null);
  const [listening, setListening] = useState(false);
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) return null;

  const insert = (t) => {
    const el = inputRef?.current;
    if (!el) { onText(t); return; }
    const start = el.selectionStart ?? el.value.length;
    const end = el.selectionEnd ?? start;
    const before = el.value.slice(0, start);
    const after = el.value.slice(end);
    const pad = before && !/\s$/.test(before) ? " " : "";
    const padAfter = after && !/^\s/.test(after) ? " " : "";
    onText(before + pad + t + padAfter + after);
    const pos = start + pad.length + t.length;
    setTimeout(() => { try { el.setSelectionRange(pos, pos); } catch { /* noop */ } }, 0);
  };

  const toggle = () => {
    if (listening) {
      recRef.current?.stop();
      return;
    }
    const rec = new SR();
    rec.lang = "hi-IN";
    rec.continuous = true;
    rec.interimResults = false;
    rec.onresult = (e) => {
      for (let i = e.resultIndex; i < e.results.length; i++) {
        if (!e.results[i].isFinal) continue;
        const t = clean(e.results[i][0].transcript);
        if (t) insert(t);
      }
    };
    rec.onerror = (e) => {
      setListening(false);
      if (e.error === "not-allowed") toast.error("Please allow microphone access");
    };
    rec.onend = () => setListening(false);
    recRef.current = rec;
    rec.start();
    setListening(true);
    toast.info("Listening… speak now", { duration: 2000 });
  };

  return (
    <button type="button" data-testid="voice-typing-button" onClick={toggle} title="Hindi voice typing"
      className={`shrink-0 rounded-md p-2 transition-all active:scale-90 ${listening ? "bg-red-500 text-white animate-pulse" : "bg-muted text-foreground hover:bg-primary/20"} ${className}`}>
      <Microphone size={18} weight={listening ? "fill" : "regular"} />
    </button>
  );
};
